<template>
    <div class="printOrderListBox">
        <el-tabs v-model="orderStatusValue" class="orderListTabs" @tab-click="searchInfo">
            <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.name" :name="item.id">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <!--<el-date-picker
                    v-model="createDateValue"
                    clearable
                    type="date"
                    placeholder="创建时间">
                </el-date-picker>-->
                <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                    <el-date-picker
                        v-model="createDateValue"
                        @change="chooseDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <el-cascader
                    v-model="materialsValue"
                    clearable
                    :options="material_printList"
                    :props="props"
                    placeholder="材料分类"></el-cascader>
                <el-input v-model="businessName" placeholder="服务商名称"></el-input>
                <el-input v-model="buyerName" placeholder="买家名称"></el-input>
                <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="clearSearch">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">打印模型</li>
                    <li class="price">单价</li>
                    <li class="num">数量</li>
                    <li class="arguments">打印参数</li>
                    <li class="payment">实付款</li>
                    <li class="status">交易状态</li>
                    <li class="status">开票状态</li>
                </ul>
                <ul class="tableBody" v-if="tableList.length != 0" v-loading="loading">
                    <li class="bodyItem" v-for="item in tableList">
                        <div class="itemTop">
                            <div>创建时间：{{item.orderBase.createDate}}</div>
                            <div>订单编号：{{item.orderBase.orderNo}}</div>
                            <div class="merchantInfo">
                                <span>服务商：</span>
                                <span>{{item.enterPriseName}}</span>
                            </div>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div>
                                    <div class="orderInfo" v-for="(info,index) in item.list" :key="index">
                                        <!-- <img :src="info.url" alt=""> -->
                                        <div class="model">
                                             <model-stl
                                                :backgroundAlpha="0"
                                                :src="info.url.toLowerCase()">
                                            </model-stl>
                                            <el-button class="preview" @click="handPreview(info)">预览</el-button>
                                        </div>

                                        <div class="infoContent">
                                            <div class="infoName" :title="info.name">{{info.name}}</div>
                                            <div class="infoOther">表面积：{{info.longSize}}*{{info.widthSize}}*{{info.heightSize}}cm</div>
                                            <div class="infoOther">体&nbsp;&nbsp;积：{{info.volume}}mm³</div>
                                            <div class="infoOther">缩&nbsp;&nbsp;放：{{info.scale}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="price">
                                <div v-for="(price,index) in item.list" :key="index"  style="line-height: 144px;">¥{{price.unitPrice}}</div>
                            </div>
                            <div class="num">
                                <div v-for="(printNum,index) in item.list" :key="index"  style="line-height: 144px;">{{printNum.printNum}}</div>
                            </div>
                            <div class="arguments">
                                <div>
                                    <div class="argumentsName">工&nbsp;&nbsp;艺：{{item.technologyName}}</div>
                                    <div class="argumentsName">材&nbsp;&nbsp;料：{{item.firstMaterialName}}/{{item.secondMaterialName}}</div>
                                    <div class="argumentsName">填&nbsp;&nbsp;充：{{item.soildUuid=='YES'?'空心':'实心'}}</div>
                                    <div class="argumentsName" v-if="item.isReprocess=='YES'">后处理：{{item.typeName}}&nbsp;|&nbsp;{{item.surfaceEffectName}}</div>
                                </div>
                            </div>
                            <div class="payment">
                                <h3>¥{{item.orderBase.totalPrice}}</h3>
                                <div class="title">(含运费：{{item.transportationPrice}}元)</div>
                            </div>
                            <div class="status">
                                <div class="statusName">{{item.orderBase.orderStatusCn}}</div>
                                <el-button type="text" class="operationBtn" @click="toDetail(item)">订单详情</el-button>
                                <el-button type="text" class="operationBtn" v-if="item.isShipments === '1'">查看物流</el-button>
                            </div>
                            <div class="status">
                                <div>{{ item.issueInvoiceType==null?"未开票":item.issueInvoiceType=="EXAMINE"?'开票中':item.issueInvoiceType=='PASS'?'已开票':'已拒绝' }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div>
            </div>
            <el-pagination
                v-if="tableList.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <!-- 3d预览 -->
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>
    </div>
</template>

<script>
import {getPrintOrderList,
    getDictionaryGroup, getDictionaryItem, findTypeListByGroupUuid } from '../../utils/interface';
import threeD from "../../components/threeD/index"
import ModelStl from 'vue-3d-model/src/model-stl'
export default {
    name: "printOrderList",
    data() {
        return {
            loading: true,
            order:{},
            tabList: [
                {
                    id: "ALL",
                    name: "全部",
                },
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "OFFLINE_UN_CONFIRM",
                    name: "线下支付待确认",
                },
                {
                    id: "DELIVERY_ON_CASH_UN_CONFIRM",
                    name: "货到付款待确认",
                },
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "UN_CANCEL",
                    name: "已取消",
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
            ],
            createDateValue: null,
            startTime:"",
            endTime:"",
            materialsValue: '',
            material_printList:[],
            props: {
                value: 'uuid',
                label: 'name',
                //lazy: true,
                checkStrictly: true,
                //lazyLoad: this.cascaderLazyLoad
            },
            buyerName: '',
            businessName: '',
            orderNo: '',
            orderStatusValue: "ALL",
            trackingNumber: '',
            multipleSelection: [],
            checkedAll: false,
            tableList: [],
            current: 1,
            total: 0,
            pageSize: 8,
            // 3D预览
            fileListNew: [],
            innerVisible: false,
        }
    },
    components: {
        threeD,
        ModelStl
    },
    created(){
        this.getPrintOrderList();
        this.getDictionaryList('material_print');
        this.getDictionaryItem();
    },
    methods: {
        searchInfo(){
            this.current = 1;
            this.getPrintOrderList();
        },
        clearSearch(){
            this.buyerName = "";
            this.businessName = "";
            this.orderNo = "";
            this.materialsValue = "";
            this.createDateValue = null;
            this.startTime = "";
            this.endTime = "";
            this.trackingNumber = "";
            this.searchInfo();
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        // 获取字典值列表
        getDictionaryList(val){
            getDictionaryGroup({parentCode:val}).then((res)=>{
                res.map((item)=>{
                    findTypeListByGroupUuid({groupUuid:item.uuid}).then((res)=>{
                        if(res){
                            item.children = res.data;
                        }
                    })
                });
                this.material_printList = res;
            });
            /*getDictionaryGroup({parentCode:val}).then((res)=>{
                if(val === 'material_print'){
                    this.material_printList = res
                }
            })*/
        },
        // 获取字典值
        getDictionaryItem() {
            getDictionaryItem({groupCode: "print_evaluation_tag"}).then((res) => {
                this.tagList = [];
                res.forEach((item, index) => {
                    this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                });
            });
        },
        getPrintOrderList(){
            this.loading = true;
            let params = {
                orderNo:this.orderNo,
                businessName:this.businessName,
                buyerName:this.buyerName,
                firstMaterialUuid:this.materialsValue.length>=1?this.materialsValue[0]:'',
                materialUuid:this.materialsValue.length==2?this.materialsValue[1]:'',
                orderStatus:this.orderStatusValue=="ALL"?"":this.orderStatusValue,
                //createDate:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
                startDate:this.startTime,
                endDate:this.endTime,
                logisticsNo:this.trackingNumber,
                current:this.current,
                pageSize:this.pageSize,
            };
            getPrintOrderList(params).then((res)=>{
                this.current = res.current;
                this.total = res.total;
                this.tableList = res.data;
                this.loading = false
            });
        },
        //级联选择器  获取二级数据
        cascaderLazyLoad(node,resolve) {
            const { level } = node;   //获取层级
            const {children} = node;    //花括号写法 表示直接取到对象里的某个属性
            const {data} = node;
            let parentId = data?data.id:"0";
            //如果不是根级菜单
            if(!node.root) {
                getDictionaryItem({groupCode: node.data.code}).then((res)=>{
                    let nodes = [];
                    if (res) {
                        for (let item of res) {
                            nodes.push({
                                uuid: item.uuid,
                                name: item.name,
                                remarks: item.remarks,
                                leaf:level <= 2               //设置能加载到的层级  此处只能加载2级
                            })
                        }
                    }
                    resolve(nodes);    //将组装好的数据暴露
                })
            }
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.getPrintOrderList();
        },
        // 跳转至详情页
        toDetail(val){
            this.$router.push({name:'printOrderDetails',params:{uuid:val.uuid}});
        },
        // 预览模型
        handPreview(info) {
            this.$refs.threeBox.threeAnimal(info);
            this.innerVisible = !this.innerVisible;
        },
        closeDlog(index){
            this.innerVisible = index;
        },
    }
}
</script>

<style scoped lang="less">
.printOrderListBox {
    background: #fff;
    min-height: 1011px;
    padding: 94px 20px 20px;
    margin-left: 20px;
    .orderListTabs{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
        margin-left: 20px;
    }
    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #E4E7ED;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }
    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }
    /deep/ .el-tabs__item.is-active {
        color: #3686d7
    }
    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
    .orderSearchBox {
        .timeSearch {
            background-color: #f2f4f7;
            height: 35px;
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-right: 30px;
            border-radius: 8px;

            span {
                font-size: 12px;
                color: #c0c4cc !important;
                font-weight: normal;
                padding-left: 15px;
                margin-right: 5px;
            }

            // /deep/ .el-range-input{
            //         background-color: #f2f4f7;
            //             &:hover, &:focus {
            //             background-color: #fff;
            //             // border: 1px solid #108EE9;
            //         }
            // }
            /deep/ input::-webkit-input-placeholder {
                color: #c0c4cc;
                font-size: 12px;
            }

            /deep/ .el-range-input:hover {
                background-color: #fff !important;
            }

            /deep/ .el-date-editor .el-range-separator {
                line-height: 25px;
                color: #c0c4cc;
            }

            /deep/ .el-date-editor .el-range__close-icon {
                line-height: 28px;
            }

            /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                background-color: white;
            }

            /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                .el-range-input {
                    background-color: #f2f4f7;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
        }
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom:22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom:22px;
        }
    }
    .orderListTable {
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356FDF;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157EFB;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157EFB;
                        box-sizing: border-box;
                        border: 1px solid #157EFB;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;

            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }
        }
        .select{
            padding: 0 20px;
        }
        .tableBody {
            li {
                width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;

                .itemTop {
                    width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            padding-right: 5px;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;

                    .orderInfo {
                        padding: 20px;
                        display: flex;
                        position: relative;

                        .model{
                            position: relative;
                            width: 134px;
                            height: 134px;
                            margin-right: 15px;
                        }
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 300px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }

                    .arguments {
                        padding: 20px;
                    }

                    .argumentsName {
                        padding-bottom: 8px;
                    }
                    .payment {
                        h3 {
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                        }

                        .title {
                            font-size: 12px;
                            color: #999999;
                        }
                    }
                    .status{
                        font-size: 14px;
                    }
                    .operationBtn{
                        display: block;
                        color: #0C75D3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }
                }
            }
        }

        .name {
            flex: 1;
            position: relative;
            display: flex;
            justify-content: center;
        }

        .price {
            width: 120px;
            text-align: center;
        }

        .num {
            width: 95px;
            text-align: center;
        }

        .arguments {
            width: 294px;
            display: flex;
            justify-content: center;
        }

        .payment {
            width: 162px;
            text-align: center;
        }

        .status {
            width: 124px;
            text-align: center;
        }

        .operation {
            width: 145px;
            text-align: center;
            .operationUploadBtn{
                width: 102px !important;
                height: 34px;
                padding: 0;
                line-height: 34px;
                text-align: center;
                font-weight: 700;
                color: rgba(0, 102, 204, 0.8);
                font-size: 14px;
                border-color: rgba(0, 102, 204, 0.8);
                display: block;
                margin: 0 auto 10px !important;
            }
        }
    }
    .preview{
        position: absolute;
        width: 100%;
        height: 25px;
        padding: 0;
        text-align: center;
        border: none;
        left: 0;
        bottom: 5px;
        background: rgba(255,255,255,.6);
        font-size: 12px;
        color: #1296DB;
        font-weight: 700;
    }
    .submitButtonGroup{
        /deep/.el-form-item__content{
            text-align: center;
            margin-left: 0 !important;
            button{
                padding: 0;
                width: 120px;
                height: 35px;
                line-height: 35px;
                text-align: center;
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}
.addressList{
    padding: 24px 15px 0;
    display: flex;
    flex-wrap: wrap;
    .addressItem{
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #E3E3E3;
        font-size: 14px;
        .addressBorder{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        &.active{
            border: 2px dashed #fff;
        }
        &:nth-of-type(4n){
            margin-right: 0;
        }
        .checkBox{
            position: absolute;
            right: 22px;
            top: 14px;
        }
        .name{
            color: #000;
        }
        .tel{
            color: rgba(51, 51, 51, 0.85);
            padding: 6px 0;
        }
        .address{
            color: rgba(51, 51, 51, 0.85);
            line-height: 22px;
        }
    }
    .addItem{
        text-align: center;
        cursor: pointer;
        color: #666;
        &:hover{
            border: 2px dashed #1890FF;
        }
        .icon{
            font-size: 30px;
        }
        .addName{
            font-size: 14px;
            padding-top: 5px;
        }
    }
}
.electronicInvoice {
    h3 {
        padding-bottom: 15px;
        color: #000;
        font-size: 15px;
    }

    .invoiceList {
        .invoiceItem {
            border: 1px solid #ddd;
            padding: 10px 50px 10px 15px;
            border-radius: 10px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            position: relative;

            .invoiceCheckBox {
                padding-right: 15px;
            }

            .type {
                font-size: 12px;
                color: #666;
                padding-bottom: 5px;
            }

            .name {
                font-size: 15px;
                color: #000;
                padding-bottom: 5px;
            }

            .num {
                font-size: 12px;
                color: #333;
            }

            .edit {
                position: absolute;
                right: 15px;
                top: 50%;
                margin-top: -10px;
                padding: 0;
            }
        }
    }

    .emailList {
        padding: 0 15px 15px;

        /deep/ .el-radio {
            margin-bottom: 15px;
            display: block;
            margin-right: 0;
        }
    }
}
.evaluateDialogBox {
    .evaluateItem {
        .name {
            font-size: 14px;
            color: #000;
            padding-bottom: 20px;
            font-weight: bold;
        }

        .content {
            padding-left: 20px;
            padding-bottom: 15px;
        }

        .rateItem {
            display: flex;
            align-items: center;
            padding-bottom: 15px;

            .name {
                padding: 0 20px 0 0;
                font-size: 13px;
                color: #333;
                min-width: 100px;
                font-weight: normal;
            }
        }

        .evaluateTag {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-checkbox-button {
                display: block;
                margin-right: 20px;
                margin-bottom: 15px;
            }

            /deep/ .el-checkbox-button__inner {
                border: 1px solid #dcdfe6 !important;
                border-radius: 4px;
                padding: 8px 15px;
                font-size: 13px;
                box-shadow: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/printOrderList.vue